import { render } from "./MedicationsView.vue?vue&type=template&id=10534137"
import script from "./MedicationsView.vue?vue&type=script&lang=js"
export * from "./MedicationsView.vue?vue&type=script&lang=js"

import "./MedicationsView.vue?vue&type=style&index=0&id=10534137&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/MedicationsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10534137"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10534137', __exports__)) {
    console.log('reload')
    api.reload('10534137', __exports__)
  }
  
  module.hot.accept("./MedicationsView.vue?vue&type=template&id=10534137", () => {
    console.log('re-render')
    api.rerender('10534137', render)
  })

}


export default __exports__